import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    Chip,
    Grid,
    Stack,
    useTheme,
    useMediaQuery
} from '@mui/material';
import {
    EmojiEvents as RankingIcon,
    Input as InputIcon,
    Download as DownloadIcon,
    Assessment as ScoreIcon
} from '@mui/icons-material';
import { localizedName } from "../../helper/LangHelper";
import { timeToDateStr } from "../../helper/StringHelper";
import { useNavigate } from "react-router-dom";
import { AdminApi } from "../../api/AdminApi";
import { downloadWithURL } from "../../helper/ExportHelper";


const createButton = (label, icon, onClick, color) => (
    <Button
        variant="contained"
        onClick={onClick}
        startIcon={icon}
        sx={{
            minWidth: '120px',
            bgcolor: color,
            '&:hover': {
                bgcolor: color
            },
            textTransform: 'none',
            py: 1.5,
            fontSize: '0.9rem',
            fontWeight: 500
        }}
    >
        {label}
    </Button>
);

const createEventTypeChip = (eventType) => {
    let name = "";
    let bgColor = "";
    let textColor = "";

    if (eventType === "fit_exam") {
        name = "體適能呈分試";
        bgColor = '#e0f7fa';
        textColor = '#006064';
    } else if (eventType === "game") {
        name = "運動比賽";
        bgColor = '#f1f8e9';
        textColor = '#33691e';
    } else {
        name = "一般活動";
        // eventType; // "未知類型";
        bgColor = '#eeeeee';
        textColor = '#424242';
    }

    return (
        <Chip
            label={name}
            sx={{
                bgcolor: bgColor,
                color: textColor,
                fontWeight: 500,
                px: 1
            }}
        />
    );
}

const configureActionList = ({ event, buttonSet }) => {
    // let actionList = [];

    const eventType = event.event_type;

    // eventType includes: "fit_exam", "game", "normal"//  const buttonSet = {
    //         inputDataButton,
    //         leaderboardOverallButton,
    //         leaderboardMonthlyButton,
    //         downloadButton,
    //         summaryButton
    //     }
    if (eventType === "fit_exam") {
        return [
            buttonSet.inputDataButton,
            buttonSet.leaderboardOverallButton,
            buttonSet.summaryButton,
            buttonSet.downloadButton,
        ]
    }

    // if (eventType === "game") {
    //     return [
    //         buttonSet.inputDataButton,
    //         buttonSet.leaderboardOverallButton,
    //         buttonSet.leaderboardMonthlyButton,
    //         buttonSet.downloadButton,
    //     ]
    // }

    // game or normal
    return [
        buttonSet.inputDataButton,
        buttonSet.leaderboardOverallButton,
        buttonSet.leaderboardMonthlyButton,
        buttonSet.downloadButton,
    ]

    // actionButtons.forEach(buttonConfig => {
    //     const { label, icon, onClick, color } = buttonConfig;
    //     const button = createButton(label, icon, onClick, color);
    //     actionList.push(button);
    // }
    // );

    return actionList;
}

const EventDetailCard = ({ event }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    const onRankingClick = () => { }
    const onDownloadClick = () => {
        AdminApi.exportHealthAndSkillSummary(
            event.id, (isSuccess, msg, result) => {
                if (isSuccess === false) {
                    alert(msg);
                }
                // console.debug(`isSuccess=${isSuccess}, msg=${msg}`);
                // console.debug(`eventID=${event.id} result: `, result);
                downloadWithURL(result.export_url, result.export_filename);
            }
        );
    }

    const onLeaderBoard = (e) => {
        console.debug("onLeaderboard");
        navigate(`/overall-dashboard/${event.id}`, { state: { event } });
    };

    const onMonthlyLeaderBoard = (e) => {
        console.debug("onMonthlyLeaderBoard");
        navigate(`/monthly-dashboard/${event.id}`, { state: { event } });
    };

    const onDataInputClick = (e) => {
        // console.debug("onDataInput");
        const options = {
            state: { event },
        };
        navigate(`/skill-list/${event.id}`, options);
    };

    const onScoreClick = (e) => {
        const options = {
            state: { event },
        };
        navigate(`/user/eventOverview/${event.id}`, options);
    }


    const eventTypeChip = createEventTypeChip(event.event_type);


    const eventName = localizedName(event, "name");

    const dateRange =
        timeToDateStr(event.start_at) + " - " + timeToDateStr(event.end_at);


    // const title = event.title || "Unknown Event Title";
    // const date = event.start_at || "Unknown Date";

    const inputDataButton = createButton(
        "數據輸入",
        <InputIcon />,
        onDataInputClick,
        '#6464e1ff'
    );

    // const leaderboardButton = createButton(
    //     "排行榜",
    //     <RankingIcon />,
    //     onRankingClick,
    //     '#6b5b5b'
    // );

    const downloadButton = createButton(
        "下載數據",
        <DownloadIcon />,
        onDownloadClick,
        '#4a7bc7'
    );

    const summaryButton = createButton(
        "呈分試報告",
        <ScoreIcon />,
        onScoreClick,
        '#c77b4a'
    );

    const leaderboardMonthlyButton = createButton(
        "每月排行榜",
        <RankingIcon />,
        onMonthlyLeaderBoard,
        '#5b6b5b'
    );

    const leaderboardOverallButton = createButton(
        "總體排行榜",
        <RankingIcon />,
        onLeaderBoard,
        '#5d775dff'
    );

    // let actionList = [];

    const buttonSet = {
        inputDataButton,
        leaderboardOverallButton,
        leaderboardMonthlyButton,
        // downloadButton,
        summaryButton
    }

    const actionList = configureActionList({ event, buttonSet });
    // actionList.push(inputDataButton);
    // actionList.push(leaderboardOverallButton);
    // actionList.push(leaderboardMonthlyButton);
    // actionList.push(downloadButton);
    // actionList.push(summaryButton);

    return (
        <Card
            sx={{
                borderRadius: 1,
                boxShadow: 1,

            }}
        >
            <CardContent>
                {/* Header */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={0}
                >
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        fontWeight={500}
                    >
                        {dateRange}
                    </Typography>
                    {eventTypeChip}
                    {/* {isCompleted && (
                        <Chip
                            label="已完成"
                            size={isMobile ? "small" : "medium"}
                            sx={{
                                bgcolor: '#f4e4d0',
                                color: '#8b6914',
                                fontWeight: 500,
                                px: 1
                            }}
                        />
                    )} */}
                </Box>

                {/* Title */}
                <Typography
                    variant={isMobile ? "h5" : "h4"}
                    component="h2"
                    fontWeight={600}
                    color="text.primary"
                    mb={1}
                >
                    {eventName}
                </Typography>

                {/* Action Buttons */}
                <Grid container spacing={2} sx={{ mt: 2 }}>
                    {
                        actionList.map((button, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                {button}
                            </Grid>
                        ))
                    }
                </Grid>

                {/* Score Button */}
                {/*  */}
            </CardContent>
        </Card>
    );
};

export default EventDetailCard;